/* eslint-disable prettier/prettier */
import { emojiIconMap } from '../../utils/emojiIconMap';
import { CollapsibleSection } from '../file/CollapsibleSection';
import { ComparisonTable } from './ComparisonTable';

export const BrokersComparisonSection = ({
  brokers,
  showDifferences,
}: {
  brokers: any[];
  showDifferences?: boolean;
}) => {
  if (!Array.isArray(brokers)) return null;
  const hasDifferences = brokers.some((broker) =>
    Object.values(broker).some((field: any) => field?.isDifferent),
  );

  if (showDifferences && !hasDifferences) return null;

  return (
    <CollapsibleSection title="Brokers" icon={emojiIconMap['Brokers']}>
      {brokers.map((broker, index) => (
        <div key={index} className="mb-4">
          <ComparisonTable
            data={broker}
            fieldLabels={{
              brokerName: 'Broker Name',
            }}
            firstLabel={`Broker ${index + 1}`}
            showDifferences={showDifferences}
          />
        </div>
      ))}
    </CollapsibleSection>
  );
};
